'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;

exports.createDataPointsArray = createDataPointsArray;

function createDataPointsArray(context, config, next) {
    var apiParsedResponseList = context.apiParsedResponseList,
        extensionObj,
        intervalList,
        intervalFilter,
        selectedInterval,
        dataKey,
        pointsResolution,
        minorIntervals,
        apiMergedResponse = {},
        rangeMidValue,
        rangeCount,
        isSelectedIntervalInList = false;


    pointsResolution = config.pointsResolution;
    intervalList = context.returnFiltersArray;
    dataKey = config.dataKey;
    if (!apiMergedResponse[dataKey]) {
        apiMergedResponse[dataKey] = [];
    }

    intervalFilter = _.find(context.filter, {
        id: 'interval'
    });
    selectedInterval = (intervalFilter && intervalFilter.value) || intervalList[0];
    
    _.forEach(intervalList, function(currentInterval){
        if(selectedInterval.min === currentInterval.min && selectedInterval.max === currentInterval.max){
            isSelectedIntervalInList = true;
        }
    });

    if(!isSelectedIntervalInList){
        selectedInterval = intervalList[0];
    }

    if (apiParsedResponseList[0][dataKey].length) {
        minorIntervals = $u.generic.generateAllMinorIntervals(
            selectedInterval, pointsResolution);
        _.forEach(minorIntervals, function(intervalRange) {
            rangeMidValue = Math.round((intervalRange[0] + intervalRange[1]) / 2);
            rangeCount = 0;
            _.forEach(apiParsedResponseList[0][dataKey], function(dataValue) {
                if (dataValue >= intervalRange[0] && dataValue <= intervalRange[1]) {
                    rangeCount = rangeCount + 1;
                }
            });

            apiMergedResponse[dataKey].push({
                x: rangeMidValue,
                y: rangeCount,
                range: [intervalRange[0], intervalRange[1]]
            });
        });
    }

    context.selectedInterval = selectedInterval;
    context.apiMergedResponse = apiMergedResponse;
    next();
}
